import React, { useState } from 'react';
import DateInput from '../../../../common/DateInput'
import DatePicker from "react-datepicker";
import Paginator from '../../../../common/Paginator'

const EditEvents = ({ accomplishments, setAccomplishments, index, setIndex, addAccomplishments }) => {
    var accomplishment = accomplishments[index]
    return (
    <div >
        <div className="mg-b-5 mg-t-15">
                <div className="modal-subheader">Event Name</div>                
                <div className="mg-b-15"><input value={accomplishment.title} onChange={(e) => setAccomplishments(e.target.value, "title")} type="text" className="form-control"></input></div>
                <div className="row">
                    <div className="col-md-6">
                    <div className="modal-subheader">Organization</div>                
                    <div className="mg-b-15"><input  value={accomplishment.association} onChange={(e) => setAccomplishments(e.target.value, "association")} type="text" className="form-control"></input></div>
                    </div>
                    <div className="col-md-6">
                    <div className="modal-subheader">Date (Month/Year)</div>
                    <DatePicker
                        selected={accomplishment.date}
                        onChange={(e) => setAccomplishments(e, "date")}
                        customInput={<DateInput/>}
                        showMonthYearPicker
                        dateFormat="MMMM, yyyy"
                    />
                    </div>
                </div>
                
                <div className="modal-subheader">Role</div>
            <div className="mg-b-15">
                <textarea  value={accomplishment.description} onChange={(e) => setAccomplishments(e.target.value, "description")} className="textarea" style={{marginTop:'0px', marginBottom:'0px', height:'70px'}}></textarea>
            </div> 
            <div className="v-align">
                <div className="wd-pct-33">
                    <Paginator index={index} length={accomplishments.length} onClick={setIndex}/>
                </div>
                <div className="wd-pct-33 text-center">{"Showing " + (index + 1) + " of " + accomplishments.length}</div>
                <div style={{marginLeft:'auto'}}>
                    <button className="btn btn-mini btn-default"  onClick={addAccomplishments}>
                        <i className="fas fa-plus mg-r-5"></i>Add Event
                        <span className="button-info">3</span>
                    </button>
                </div>
            </div>
        </div>
  </div>   
)}
export default EditEvents;